import * as React from 'react';
import { st, classes } from './CoreDropdownOption.st.css';
import { createOptionLabelId } from '../../../../Dropdown/helpers';
export const CoreDropdownOption = (props) => {
    const { id, option, isSelected, isHovered, onClickHandler, onMouseEnterHandler, onMouseLeaveHandler, dataHook, unavailable, } = props;
    const disabled = option.isDisabled;
    const selectable = option.isSelectable;
    const hovered = !disabled && isHovered;
    const selected = !disabled && isSelected;
    const optionDisabled = !selectable || disabled || unavailable;
    const ariaProps = selectable
        ? {
            role: 'option',
            'aria-selected': selected,
            'aria-disabled': optionDisabled,
            disabled: optionDisabled,
        }
        : {
            role: 'option',
            'aria-disabled': optionDisabled,
            disabled: optionDisabled,
        };
    return (React.createElement("div", { id: id, tabIndex: -1, className: st(classes.root, { disabled, selectable, hovered, selected }, props.className), "aria-labelledby": id && createOptionLabelId(id), "data-hook": dataHook, ...ariaProps, onClick: onClickHandler, title: option.value, onMouseEnter: onMouseEnterHandler, onMouseLeave: onMouseLeaveHandler }, option.render(option.value)));
};
CoreDropdownOption.displayName = 'CoreDropdownOption';
//# sourceMappingURL=CoreDropdownOption.js.map